//
//
//
//
//
//

export default {
  name: 'CheckRobotPage',
  head () {
    const icon = (this.$store.state.isWiki == '1' || this.$store.state.isWiki == '3') ? 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico' : 'https://resources1.interface003.com/web20/img/favicon-fxeye.ico'
    return {
      title: '人机检验-WikiFX',
      link: [{ rel: 'icon', type: 'image/x-icon', href: icon }],
      meta: [
        { name: 'description', content: 'WikiFX：人机检验。' }
      ]
    }
  }
}
